<script>
  export let tninfodata = {};

  let showPage = 1;

  function processTnInfo(myTninfodata) {
    tninfodata = myTninfodata;
  }

  $: processTnInfo(tninfodata);
</script>

{#if tninfodata && !(Object.keys(tninfodata).length === 0 && tninfodata.constructor === Object) && tninfodata.hasKongress == 1}
  <div id="terminePanel">
    <div id="panelHeader">
      <h3>Ihre persönliche Terminübersicht<span class="glyphicon glyphicon-remove-sign terminePanelClose" /></h3>
    </div>
    <!-- SEITE 1 START ******************************************************************** -->
    {#if showPage == 1}
      <div id="panelContent01">
        <h3>Kurzübersicht</h3>
        <p>
          Hier finden Sie eine Kurzübersicht Ihrer gebuchten Workshops, Gruppengespr&auml;che und One to Ones. Au&szlig;erdem sehen Sie, inwieweit sich Ihre gebuchten Termine mit den
          Starvortr&auml;gen überschneiden.
        </p>
        <p class="legende">
          <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_ws_black.gif" width="16" height="20" alt="Workshop" title="Workshop" /><strong>WS</strong>: Workshop |
          <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_gg_black.gif" width="16" height="20" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><strong>GG</strong>: Gruppengespr&auml;ch
          | <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_oo_black.gif" width="16" height="20" alt="One to One" title="One to One" /><strong>o2o</strong>: One to One
        </p>
        <table border="0" cellspacing="0" cellpadding="0" class="appointmentOutline">
          <tr>
            <th colspan="2" class="date">{tninfodata.kongressDay1Name}, {tninfodata.kongressDate1}</th>
            <th colspan="2" class="date">{tninfodata.kongressDay2Name}, {tninfodata.kongressDate2}</th>
          </tr>
          <tr>
            <td width="15%" class="time">08:00-08:30</td>
            <td width="35%" rowspan="25" class="diagram">
              <div class="wrapper" id="timetable_tag1">
                <!-- FIXE TERMINE ERSTER TAG ********************************** -->
                <!--
foreach($arr_fixedTimetableConfig as $fixed){
	if($fixed['date'] == $this->kongressobj->getTag1Formatiert("kurz")){
		$fixedDate 		= $fixed['date'];
		$fixedStartTime = $fixed['startTime'];
		$fixedEndTime 	= $fixed['endTime'];
		$fixedType 		= $fixed['type'];
		$topSpacing 	= getTopSpacing($fixedDate, $fixedStartTime, $timetableStartTime);
		if($fixedEndTime){
			$fixedDuration 	= getLectureDuration($fixedDate, $fixedStartTime, $fixedEndTime);
		}
		if($fixedEndTime){
			if($fixedType == 'Mittagspause'){

									<div class="fixedTimetable lunch" style="top: <?= $topSpacing ?>px; height: <?= $fixedDuration ?>px;">
									<p style="margin: 0;"><?= $fixedStartTime ?>-<?= $fixedEndTime ?>
										<br /><strong><?= $fixed['teaser']; ?></strong></p>
									<p style="font-size: 10px; line-height: normal; margin: 0;">Kaffee- und Dessertvariationen im Sponsorenbereich</p>
									</div>

			} else {

									<div class="fixedTimetable" style="top: <?= $topSpacing ?>px; height: <?= $fixedDuration ?>px;">
										<p style="margin: 0;"><?= $fixedStartTime ?>-<?= $fixedEndTime ?>
											<br /><strong><?= $fixedType ?></strong></p>
									</div>

			}
		} else {

					<div class="fixedTimetable" style="top: <?= $topSpacing ?>px;">
						<p style="margin: 0;"><?= $fixedStartTime ?>
							<br /><strong><?= $fixedType ?></strong></p>
					</div>

		}
	}
}

-->
                <!-- PERSÖNLICHE TERMINE ERSTER TAG ************************** -->
                <!--
$hasModeratorTermin=false;
if(!empty($this->stunden_veranstaltung_ids)) {
	foreach($this->stunden_veranstaltung_ids as $veranstaltung_id){
		$veranstaltung=new FP_Veranstaltung($veranstaltung_id);
		if($veranstaltung->getTyp()==3) {
			$teilnehmerBlocknummer=0;
			foreach($veranstaltung->o2oliste as $blocknummer=>$termin) {
				if($termin["teilnehmer_id"]==$this->teilnehmer_id) $teilnehmerBlocknummer=$blocknummer;
			}
			if($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=10) $startDate=$this->kongressobj->getTag1Formatiert("kurz");
			elseif($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=20) $startDate=$this->kongressobj->getTag2Formatiert("kurz");
			else $startDate="";
			$startEnde=$veranstaltung->getBlockZeitData($teilnehmerBlocknummer);
			$lectureStartTime 	= $startEnde[0];
			$lectureEndTime 	= $startEnde[1];
		} else {
			$lectureStartTime 	= $veranstaltung->getStartZeit();
			$lectureEndTime 	= $veranstaltung->getEndeZeit();
			$startDate=$veranstaltung->getStartDatum($format='dd.MM.YYYY');
		}

		$isModerator=false;
		if($veranstaltung->getReferent2Id()==$this->teilnehmer_id) {
			$isModerator=true;
			$hasModeratorTermin=true;
		}
		if($startDate == $this->kongressobj->getTag1Formatiert("kurz")){

			$lectureDate 		= $veranstaltung->getStartDatum($format='dd.MM.YYYY');
			$lectureType 		= $veranstaltung->getTyp();
			$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
			$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);
			switch($lectureType){
				case 1:
				case 4:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_ws_white.gif';
					break;
				case 2:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_gg_white.gif';
					break;
				case 3:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_oo_white.gif';
					break;
				default:
					$lectureIcon = '';
			}

					<a class="personalTimetableDetails" href="javascript:void(0);" id="timetable_vid_<?php echo $veranstaltung_id; ?>">
						<p class="personalTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px"><?= $lectureStartTime ?>-<?= $lectureEndTime ?><br />

if($lectureType==4) {

						Frühstücks-<br/>Workshop

} elseif($lectureType==7 || $lectureType==8 || $lectureType==9 || $lectureType==10 || $lectureType==11 || $lectureType==12) {

						IM Spezial

} else {

						<img src="<?= $lectureIcon ?>" width="16" height="20" /><span><?php echo $veranstaltung->getTypTextShort($lectureType).($isModerator?' Moderator':''); ?></span>

}

						</p>
					</a>

		}
	}
}
-->

                <!-- KEYNOTESPEAKER ERSTER TAG ************************** -->
                <!--
foreach($this->keynotesspeaker as $veranstaltung){
	if($veranstaltung->start_day == $this->kongressobj->getTag1Formatiert("kurz")){
		$lectureDate 		= $veranstaltung->start_day;
		$lectureStartTime 	= $veranstaltung->start_time;
		$lectureEndTime 	= $veranstaltung->ende_time;
		$lectureSpeaker 	= $veranstaltung->referent1_nachname;
		$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
		$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong><?php echo htmlentities($lectureSpeaker,ENT_COMPAT,'UTF-8'); ?></strong></p>

	}
}
-->
                <!-- Fruehstuecksworkshop ERSTER TAG ************************** -->
                <!--
foreach($this->fruehstuecksworkshop as $veranstaltung){
	if($veranstaltung->start_day == $this->kongressobj->getTag1Formatiert("kurz")){
		$lectureDate 		= $veranstaltung->start_day;
		$lectureStartTime 	= $veranstaltung->start_time;
		$lectureEndTime 	= $veranstaltung->ende_time;
		$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
		$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong>Frühstücks-<br/>Workshop</strong></p>

	}
}
-->
                <!-- IM-Spezial ERSTER TAG ************************** -->
                <!--
if($this->kongressobj->getIMSpezialTag() == 1){
    $lectureDate 		= $this->kongressobj->getTag1Formatiert("kurz");
    $lectureStartTime 	= $this->kongressobj->getIMSpezialStart();
    $lectureEndTime 	= $this->kongressobj->getIMSpezialEnde();
	$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
	$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong>IM Spezial</strong></p>

}

				</div>
				</td>
				<td width="15%" class="time">08:00-08:30</td>
				<td width="35%" rowspan="25" class="diagram">
				<div class="wrapper" id="timetable_tag2">
-->
                <!-- FIXE TERMINE ZWEITER TAG ********************************** -->
                <!--
foreach($arr_fixedTimetableConfig as $fixed){
	if($fixed["date"] == $this->kongressobj->getTag2Formatiert("kurz")){
		$fixedDate 		= $fixed['date'];
		$fixedStartTime 	= $fixed['startTime'];
		$fixedEndTime 	= $fixed['endTime'];
		$fixedType 		= $fixed['type'];
		$topSpacing 	= getTopSpacing($fixedDate, $fixedStartTime, $timetableStartTime);
		if($fixedEndTime){
			$fixedDuration 	= getLectureDuration($fixedDate, $fixedStartTime, $fixedEndTime);
		}
		if($fixedEndTime){
			if($fixedType == 'Mittagspause'){


									<div class="fixedTimetable lunch" style="top: <?= $topSpacing ?>px; height: <?= $fixedDuration ?>px;">
										<p style="margin: 0;"><?= $fixedStartTime ?>-<?= $fixedEndTime ?>
											<br /><strong><?= $fixed['teaser']; ?></strong></p>
										<p style="font-size: 10px; line-height: normal; margin: 0;">Kaffee- und Dessertvariationen im Sponsorenbereich</p>
									</div>

			} else {

									<div class="fixedTimetable" style="top: <?= $topSpacing ?>px; height: <?= $fixedDuration ?>px;">
										<p style="margin: 0;"><?= $fixedStartTime ?>-<?= $fixedEndTime ?>
											<br /><strong><?= $fixedType ?></strong></p>
									</div>

			}
		} else {

					<div class="fixedTimetable" style="top: <?= $topSpacing ?>px;">
						<p style="margin: 0;"><?= $fixedStartTime ?>
							<br /><strong><?= $fixedType ?></strong></p>
					</div>

		}
	}
}
-->

                <!-- PERSÖNLICHE TERMINE ZWEITER TAG ************************** -->
                <!--
if(is_array($this->stunden_veranstaltung_ids)) {
	foreach($this->stunden_veranstaltung_ids as $veranstaltung_id){
		$veranstaltung=new FP_Veranstaltung($veranstaltung_id);

		if($veranstaltung->getTyp()==3) {
			$teilnehmerBlocknummer=0;
			foreach($veranstaltung->o2oliste as $blocknummer=>$termin) {
				if($termin["teilnehmer_id"]==$this->teilnehmer_id) $teilnehmerBlocknummer=$blocknummer;
			}
			if($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=10) $startDate=$this->kongressobj->getTag1Formatiert("kurz");
			elseif($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=20) $startDate=$this->kongressobj->getTag2Formatiert("kurz");
			else $startDate="";
			$startEnde=$veranstaltung->getBlockZeitData($teilnehmerBlocknummer);
			$lectureStartTime 	= $startEnde[0];
			$lectureEndTime 	= $startEnde[1];
		} else {
			$lectureStartTime 	= $veranstaltung->getStartZeit();
			$lectureEndTime 	= $veranstaltung->getEndeZeit();
			$startDate=$veranstaltung->getStartDatum($format='dd.MM.YYYY');
		}

		$isModerator=false;
		if($veranstaltung->getReferent2Id()==$this->teilnehmer_id) {
			$isModerator=true;
			$hasModeratorTermin=true;
		}
		if($startDate == $this->kongressobj->getTag2Formatiert("kurz")){
			$lectureDate = $veranstaltung->getStartDatum($format='dd.MM.YYYY');
			$lectureType 		= $veranstaltung->getTyp();
			$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
			$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);
			switch($lectureType){
				case 1:
				case 4:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_ws_white.gif';
					break;
				case 2:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_gg_white.gif';
					break;
				case 3:
					$lectureIcon = '/content/im/templates/img/Kongresstool/ico_oo_white.gif';
					break;
				default:
					$lectureIcon = '';
			}

					<a class="personalTimetableDetails" href="javascript:void(0);" id="timetable_vid_<?php echo $veranstaltung_id; ?>"><p class="personalTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px"><?= $lectureStartTime ?>-<?= $lectureEndTime ?><br />
						<?php if($lectureIcon!="") { ?><img src="<?= $lectureIcon ?>" width="16" height="20" /><?php } ?><span><?php echo $veranstaltung->getTypTextShort($lectureType).($isModerator?' Moderator':''); ?></span></p></a>

		}
	}
}
-->

                <!-- KEYNOTESPEAKER ZWEITER TAG ************************** -->
                <!--
foreach($this->keynotesspeaker as $veranstaltung){
	if($veranstaltung->start_day == $this->kongressobj->getTag2Formatiert("kurz")){
		$lectureDate 		= $veranstaltung->start_day;
		$lectureStartTime 	= $veranstaltung->start_time;
		$lectureEndTime 	= $veranstaltung->ende_time;
		$lectureSpeaker 	= $veranstaltung->referent1_nachname;
		$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
		$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong><?php echo htmlentities($lectureSpeaker,ENT_COMPAT,'UTF-8'); ?></strong></p>

	}
}
-->
                <!-- Fruehstuecksworkshop ZWEITER TAG ************************** -->
                <!--
foreach($this->fruehstuecksworkshop as $veranstaltung){
	if($veranstaltung->start_day == $this->kongressobj->getTag2Formatiert("kurz")){
		$lectureDate 		= $veranstaltung->start_day;
		$lectureStartTime 	= $veranstaltung->start_time;
		$lectureEndTime 	= $veranstaltung->ende_time;
		$lectureSpeaker 	= $veranstaltung->referent1_nachname;
		$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
		$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong>Stiftungs-<br/>Workshop</strong></p>

	}
}
-->
                <!-- IM-Spezial ZWEITER TAG ************************** -->
                <!--
if($this->kongressobj->getIMSpezialTag() == 2){
    $lectureDate 		= $this->kongressobj->getTag1Formatiert("kurz");
    $lectureStartTime 	= $this->kongressobj->getIMSpezialStart();
    $lectureEndTime 	= $this->kongressobj->getIMSpezialEnde();
	$topSpacing 		= getTopSpacing($lectureDate, $lectureStartTime, $timetableStartTime);
	$lectureDuration 	= getLectureDuration($lectureDate, $lectureStartTime, $lectureEndTime);

					<p class="keynotespeakerTimetable" style="top: <?= $topSpacing ?>px; height: <?= $lectureDuration ?>px;"><?= $lectureStartTime ?>-<?= $lectureEndTime ?>
						<br /><strong>IM Spezial</strong></p>

}

-->
              </div>
            </td>
          </tr>
          <tr>
            <td class="time">08:30-09:00</td>
            <td class="time">08:30-09:00</td>
          </tr>
          <tr>
            <td class="time">09:00-09:30</td>
            <td class="time">09:00-09:30</td>
          </tr>
          <tr>
            <td class="time">09:30-10:00</td>
            <td class="time">09:30-10:00</td>
          </tr>
          <tr>
            <td class="time">10:00-10:30</td>
            <td class="time">10:00-10:30</td>
          </tr>
          <tr>
            <td class="time">10:30-11:00</td>
            <td class="time">10:30-11:00</td>
          </tr>
          <tr>
            <td class="time">11:00-11:30</td>
            <td class="time">11:00-11:30</td>
          </tr>
          <tr>
            <td class="time">11:30-12:00</td>
            <td class="time">11:30-12:00</td>
          </tr>
          <tr>
            <td class="time">12:00-12:30</td>
            <td class="time">12:00-12:30</td>
          </tr>
          <tr>
            <td class="time">12:30-13:00</td>
            <td class="time">12:30-13:00</td>
          </tr>
          <tr>
            <td class="time">13:00-13:30</td>
            <td class="time">13:00-13:30</td>
          </tr>
          <tr>
            <td class="time">13:30-14:00</td>
            <td class="time">13:30-14:00</td>
          </tr>
          <tr>
            <td class="time">14:00-14:30</td>
            <td class="time">14:00-14:30</td>
          </tr>
          <tr>
            <td class="time">14:30-15:00</td>
            <td class="time">14:30-15:00</td>
          </tr>
          <tr>
            <td class="time">15:00-15:30</td>
            <td class="time">15:00-15:30</td>
          </tr>
          <tr>
            <td class="time">15:30-16:00</td>
            <td class="time">15:30-16:00</td>
          </tr>
          <tr>
            <td class="time">16:00-16:30</td>
            <td class="time">16:00-16:30</td>
          </tr>
          <tr>
            <td class="time">16:30-17:00</td>
            <td class="time">16:30-17:00</td>
          </tr>
          <tr>
            <td class="time">17:00-17:30</td>
            <td class="time">17:00-17:30</td>
          </tr>
          <tr>
            <td class="time">17:30-18:00</td>
            <td class="time">17:30-18:00</td>
          </tr>
          <tr>
            <td class="time">18:00-18:30</td>
            <td class="time">18:00-18:30</td>
          </tr>
          <tr>
            <td class="time">18:30-19:00</td>
            <td class="time">18:30-19:00</td>
          </tr>
          <tr>
            <td class="time">19:00-19:30</td>
            <td class="time">19:00-19:30</td>
          </tr>
          <tr>
            <td class="time">19:30-20:00</td>
            <td class="time">19:30-20:00</td>
          </tr>
          <tr>
            <td class="time">20:00-20:30</td>
            <td class="time">20:00-20:30</td>
          </tr>
        </table>
        <div class="spacer"><img src="/content/im/templates/img/Kongresstool/spacer.gif" width="1" height="12" alt="" title="" /></div>
      </div>
    {/if}
    <!-- SEITE 1 END ********************************************************************** -->

    <!-- SEITE 2 START ******************************************************************** -->
    {#if showPage == 2}
      <div id="panelContent02">
        <h3>Detaillansicht</h3>
        <p>
          Hier finden Sie eine detaillierte &Uuml;bersicht Ihrer gebuchten Workshops, Gruppengespr&auml;che und One to Ones. Sie können sich von einzelnen Terminen abmelden und diese in Ihren Kalender
          (im ics-Format) eintragen.
        </p>
        <p class="legende">
          <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_ws_black.gif" width="16" height="20" alt="Workshop" title="Workshop" /><strong>WS</strong>: Workshop |
          <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_gg_black.gif" width="16" height="20" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><strong>GG</strong>: Gruppengespr&auml;ch
          | <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_oo_black.gif" width="16" height="20" alt="One to One" title="One to One" /><strong>o2o</strong>: One to One
        </p>
        <hr />
        <h3 class="buttonKeynote">
          <img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" alt="" title="" /> <span>Termine der Keynote-Speaker</span>
          <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" />
        </h3>

        <!-- TABELLE KEYNOTE SPEAKER ************************************************ -->
        <table style="margin-top: 6px; display: none;" class="tableKeynote">
          <tr>
            <th>Speaker</th>
            <th>Thema</th>
            <th>Datum</th>
            <th>Uhrzeit</th>
            <th>Ort</th>
          </tr>
          <!--
foreach($this->keynotesspeaker as $veranstaltung) {

			<tr class="dataRow">
				<td><strong><?php echo htmlentities((!empty($veranstaltung->referent1_titel)?$veranstaltung->referent1_titel." ":"").$veranstaltung->referent1_vorname." ".$veranstaltung->referent1_nachname,ENT_COMPAT,'UTF-8'); ?></strong><?php

				?></td>
				<td><a href="<?php echo $this->kongressobj->getImkStarreferentenUrl(); ?>"><?php echo htmlentities($veranstaltung->titel,ENT_COMPAT,'UTF-8'); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_day; ?></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_time."-".$veranstaltung->ende_time; ?></td>
				<td style="white-space: nowrap;"><?php echo htmlentities($veranstaltung->ort,ENT_COMPAT,'UTF-8'); ?></td>
			</tr>

}
-->
        </table>

        <!-- TABELLE FRÜHSTÜCKSWORKSHOPS UND PODIUMSDISKUSSIONEN ************************************************ -->
        <h3 class="buttonPodium">
          <img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" alt="" title="" /> <span>Exklusiv: Frühstücksworkshop</span>
          <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" />
        </h3>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" style="margin-top: 6px; display: none;" class="tablePodium">
          <tr>
            <th>Typ</th>
            <th>Thema</th>
            <th>Datum</th>
            <th>Uhrzeit</th>
          </tr>
          <!--
foreach($this->sonstigeveranstaltungen as $veranstaltung) {

			<tr class="dataRow">
				<td><strong><?php echo htmlentities($veranstaltung->typbezeichnung,ENT_COMPAT,'UTF-8'); ?></strong></td>
				<td><a href="<?php echo $this->kongressobj->getImkFruehstuecksWsPdUrl(); ?>"><?php echo htmlentities($veranstaltung->titel,ENT_COMPAT,'UTF-8'); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_day; ?></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_time."-".$veranstaltung->ende_time; ?></td>
			</tr>

}
-->
        </table>

        <!-- TABELLE IM-Spezial ************************************************ -->
        <h3 class="buttonIMSpezial">
          <img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" alt="" title="" /> <span>Exklusiv: IM Spezial</span>
          <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" />
        </h3>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" style="margin-top: 6px; display: none;" class="tableIMSpezial">
          <tr>
            <th>Typ</th>
            <th>Thema</th>
            <th>Datum</th>
            <th>Uhrzeit</th>
          </tr>
          <!--
foreach($this->imspezialveranstaltungen as $veranstaltung) {

			<tr class="dataRow">
				<td><strong><?php echo htmlentities(str_replace("IM-Spezial ","",$veranstaltung->typbezeichnung),ENT_COMPAT,'UTF-8'); ?></strong></td>
				<td><a href="<?php echo $this->kongressobj->getImkIMSpezialUrl(); ?>"><?php echo htmlentities($veranstaltung->titel,ENT_COMPAT,'UTF-8'); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_day; ?></td>
				<td style="white-space: nowrap;"><?php echo $veranstaltung->start_time."-".$veranstaltung->ende_time; ?></td>
			</tr>

}
-->
        </table>

        <!--
if($hasModeratorTermin) {
-->
        <!-- TABELLE MODERIERTE VERANSTALTUNGEN ************************************************ -->
        <!--
        <h3 class="buttonModeration"><img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" /> <span>Ihr Gruppengesprächstermin</span> <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" /></h3>
		<table width="100%" border="0" cellspacing="0" cellpadding="0" class="tableModeration" id="termintable_fixedseat">
			<tr>
				<th>Typ</th>
				<th>Thema/Firma</th>
				<th>Referent</th>
				<th>Tag</th>
				<th>Uhrzeit</th>
				<th colspan="2">Ort</th>
			</tr>

	if(is_array($this->veranstaltung_ids)) {
		foreach($this->veranstaltung_ids as $veranstaltung_id) {
			$veranstaltung=new FP_Veranstaltung($veranstaltung_id);
			if($veranstaltung->getReferent2Id()==$this->teilnehmer_id) {

			<tr class="dataRow" id="termintable_vid_<?php echo $veranstaltung_id; ?>">
				<td><?php
				$titel="";
				$referent="";
				if($veranstaltung->getTyp()==1) {
					echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_ws_black.gif" width="16" height="20" alt="Workshop" title="Workshop" /><strong>WS</strong>';
					$titel=$veranstaltung->getTitel();
					$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().", ".$veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
					$referent2=htmlentities((!empty($veranstaltung->getReferent2Titel)?$veranstaltung->getReferent2Titel()." ":"").$veranstaltung->getReferent2Vorname()." ".$veranstaltung->getReferent2Nachname(),ENT_COMPAT,"UTF-8");
					if(trim($referent2)!="") $referent.=", ".$referent2.", ".htmlentities($veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
					$ort="";
					$ort="Saal ".$veranstaltung->getOrt();
				} elseif($veranstaltung->getTyp()==2) {
					echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_gg_black.gif" width="16" height="20" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><strong>GG</strong>';
					$titel=$veranstaltung->getTitel();
					$referent="<b>Fragen:</b> ";
					$referent2titel=$veranstaltung->getReferent2Titel();
					$referent.=htmlentities((!empty($referent2titel)?$referent2titel." ":""),ENT_COMPAT);
					$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Vorname()),ENT_COMPAT)." ";
					$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Nachname()),ENT_COMPAT).", ";
					$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Firmenname()),ENT_COMPAT)."<br/>";
					$referent.="<b>Antworten</b>: ".
						htmlentities((!empty($veranstaltung->getReferent1Titel)?utf8_decode($veranstaltung->getReferent1Titel())." ":"").utf8_decode($veranstaltung->getReferent1Vorname())." ".utf8_decode($veranstaltung->getReferent1Nachname()).", ".utf8_decode($veranstaltung->getAussteller_Name()),ENT_COMPAT);
					$ort="Raum ".$veranstaltung->getOrt();
				} elseif($veranstaltung->getTyp()==3) {
					echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_oo_black.gif" width="16" height="20" alt="One to One" title="One to One" /><strong>o2o</strong>';
					$titel=$veranstaltung->getAussteller_Name();
					$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname(),ENT_COMPAT,"UTF-8");
					$ort="".$veranstaltung->getOrt();

				}
				if($veranstaltung->getTyp()==3) {
					$teilnehmerBlocknummer=0;
					foreach($veranstaltung->o2oliste as $blocknummer=>$termin) {
						if($termin["teilnehmer_id"]==$this->teilnehmer_id) $teilnehmerBlocknummer=$termin["termin_blocknummer"];
					}
					if($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=10) $startdatum=$this->kongressobj->getTag1Formatiert("kurz");
					elseif($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=20) $startdatum=$this->kongressobj->getTag2Formatiert("kurz");
					else $startdatum="";
					$startEnde=$veranstaltung->getBlockZeitData($teilnehmerBlocknummer);
		#error_log("view t-vvi: ".$termin->kg_veranstaltung_veranstaltung_id." - sE: ".print_r($startEnde,true)." - t-tbn: ".$teilnehmerBlocknummer);
					$lectureStartTime 	= $startEnde[0];
					$lectureEndTime 	= $startEnde[1];
				} else {
					$startdatum=$veranstaltung->getStartDatum('dd.MM.YYYY');
					$lectureStartTime 	= $veranstaltung->getStartZeit();
					$lectureEndTime 	= $veranstaltung->getEndeZeit();
				}
				?></td>

				if($this->kongressobj->getKongressId()<70) {
					$link='/kongress/kongress-'.$this->kongressobj->getTag1Formatiert('year').'/workshops-gruppengespraeche-one-to-one/';
				} else {
					$link='/kongress/workshops-gruppengespraeche-one-to-one/';
				}

				<td><a href="<?php echo $link; ?>?vid=<?php echo $veranstaltung->getVeranstaltung_id()."&gid=".$veranstaltung->getAussteller_id()."&gt=".$veranstaltung->getTyp(); ?>" style="text-decoration: underline;"><?php echo htmlentities($titel,ENT_COMPAT,"UTF-8"); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td><?php echo $referent; ?></td>
				<td style="white-space: nowrap;"><?php echo $startdatum; ?></td>
				<td style="white-space: nowrap;"><?php echo $lectureStartTime."-".$lectureEndTime; ?></td>
				<td style="white-space: nowrap;"><?php echo $ort; ?></td>
				<td style="text-align: right; white-space: nowrap;"><a href="?eID=icsterminkgv&k=<?php echo $this->kongressobj->getKongressId()."&tid=".$terminId; ?>" target="_blank" style="padding-right: 3px;"><img src="/content/im/templates/img/callendarIco.png" width="16" height="16" alt="In Kalender eintragen" title="In Kalender eintragen" /></a>

				if($this->teilnehmer_id!=$veranstaltung->getReferent2Id()) {

				<a href="javascript:void(0)" onClick="cancelVeranstaltung(<?php echo $veranstaltung_id; ?>);"><img src="/content/im/templates/img/round_delete_black.png" width="16" height="16" alt="Termin löschen" title="Termin löschen" /></a>

				}

				</td>
			</tr>

			}
		}
	}

		</table

}
-->

        <!-- TABELLE RESERVIERTE VERANSTALTUNGEN ************************************************ -->
        <h3 class="buttonReservation">
          <img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" alt="" title="" />
          <span>Für folgende Veranstaltungen ist für Sie ein Sitzplatz reserviert</span>
          <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" />
        </h3>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="tableReservation" id="termintable_fixedseat">
          <tr>
            <th>Typ</th>
            <th>Thema/Firma</th>
            <th>Referent</th>
            <th>Tag</th>
            <th>Uhrzeit</th>
            <th colspan="2">Ort</th>
          </tr>
          <!--
if(is_array($this->veranstaltung_ids)) {
	foreach($this->veranstaltung_ids as $veranstaltung_id) {
		$veranstaltung=new FP_Veranstaltung($veranstaltung_id);
		if($veranstaltung->getReferent2Id()!==$this->teilnehmer_id) {
			$terminId=0;
			foreach($veranstaltung->getTeilnehmerliste() as $teilnehmerentry) {
				if($teilnehmerentry->teilnehmer_id==$this->teilnehmer->teilnehmer_id) $terminId=$teilnehmerentry->termin_id;
			}

			<tr class="dataRow" id="termintable_vid_<?php echo $veranstaltung_id; ?>">
				<td><?php
			$titel="";
			$referent="";
			if($veranstaltung->getTyp()==1) {
				echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_ws_black.gif" width="16" height="20" alt="Workshop" title="Workshop" /><strong>WS</strong>';
				$titel=$veranstaltung->getTitel();
				$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().", ".$veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
				$referent2=htmlentities((!empty($veranstaltung->getReferent2Titel)?$veranstaltung->getReferent2Titel()." ":"").$veranstaltung->getReferent2Vorname()." ".$veranstaltung->getReferent2Nachname(),ENT_COMPAT,"UTF-8");
				if(trim($referent2)!="") $referent.=", ".$referent2.", ".htmlentities($veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
				$ort="";
				$ort="Saal ".$veranstaltung->getOrt();
			} elseif($veranstaltung->getTyp()==2) {
				echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_gg_black.gif" width="16" height="20" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><strong>GG</strong>';
				$titel=$veranstaltung->getTitel();
				$referent="<b>Fragen:</b> ";
				$referent2titel=$veranstaltung->getReferent2Titel();
				$referent.=htmlentities((!empty($referent2titel)?$referent2titel." ":""),ENT_COMPAT);
				$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Vorname()),ENT_COMPAT)." ";
				$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Nachname()),ENT_COMPAT).", ";
				$referent.=htmlentities(utf8_decode($veranstaltung->getReferent2Firmenname()),ENT_COMPAT)."<br/>";
				$referent.="<b>Antworten</b>: ".
					htmlentities((!empty($veranstaltung->getReferent1Titel)?utf8_decode($veranstaltung->getReferent1Titel())." ":"").utf8_decode($veranstaltung->getReferent1Vorname())." ".utf8_decode($veranstaltung->getReferent1Nachname()).", ".utf8_decode($veranstaltung->getAussteller_Name()),ENT_COMPAT);
				$ort="Raum ".$veranstaltung->getOrt();
			} elseif($veranstaltung->getTyp()==3) {
				echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_oo_black.gif" width="16" height="20" alt="One to One" title="One to One" /><strong>o2o</strong>';
				$titel=$veranstaltung->getAussteller_Name();
				$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname(),ENT_COMPAT,"UTF-8");
				$ort="".$veranstaltung->getOrt();

			} elseif($veranstaltung->getTyp()>3) {
				echo $veranstaltung->getTypTextShort($veranstaltung->getTyp());

				$titel=$veranstaltung->getTitel();
				$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().($veranstaltung->getTyp()!=11?", ".$veranstaltung->getAussteller_Name():""),ENT_COMPAT,"UTF-8");
				$referent2=htmlentities((!empty($veranstaltung->getReferent2Titel)?$veranstaltung->getReferent2Titel()." ":"").$veranstaltung->getReferent2Vorname()." ".$veranstaltung->getReferent2Nachname(),ENT_COMPAT,"UTF-8");
				if($veranstaltung->getTyp()!=11 && trim($referent2)!="") $referent.=", ".$referent2.", ".htmlentities($veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");

				if($veranstaltung->getTyp()==4 || $veranstaltung->getTyp()==5 || $veranstaltung->getTyp()==7 || $veranstaltung->getTyp()==8 || $veranstaltung->getTyp()==9 || $veranstaltung->getTyp()==10 || $veranstaltung->getTyp()==12) {
					$referent="Diskussion";
				}

				$ortTemp=$veranstaltung->getOrt();
				if($ortTemp=="Großer Saal") $ortTemp="Großer Saal";
				else $ort="Saal ".$veranstaltung->getOrt();
			}
			if($veranstaltung->getTyp()==3) {
				$teilnehmerBlocknummer=0;
				foreach($veranstaltung->o2oliste as $blocknummer=>$termin) {
					if($termin["teilnehmer_id"]==$this->teilnehmer_id) $teilnehmerBlocknummer=$termin["termin_blocknummer"];
				}
				if($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=10) $startdatum=$this->kongressobj->getTag1Formatiert("kurz");
				elseif($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=20) $startdatum=$this->kongressobj->getTag2Formatiert("kurz");
				else $startdatum="";
				$startEnde=$veranstaltung->getBlockZeitData($teilnehmerBlocknummer);
	#error_log("view t-vvi: ".$termin->kg_veranstaltung_veranstaltung_id." - sE: ".print_r($startEnde,true)." - t-tbn: ".$teilnehmerBlocknummer);
				$lectureStartTime 	= $startEnde[0];
				$lectureEndTime 	= $startEnde[1];
			} else {
				$startdatum=$veranstaltung->getStartDatum('dd.MM.YYYY');
				$lectureStartTime 	= $veranstaltung->getStartZeit();
				$lectureEndTime 	= $veranstaltung->getEndeZeit();
			}
				?></td>

			if($this->kongressobj->getKongressId()<70) {
				$link='/kongress/kongress-'.$this->kongressobj->getTag1Formatiert('year').'/workshops-gruppengespraeche-one-to-one/';
			} else {
				if($veranstaltung->getTyp()==6 || $veranstaltung->getTyp()==13) {
					$link='/kongress/vortraege-der-starreferenten/';
				} elseif($veranstaltung->getTyp()==4 || $veranstaltung->getTyp()==5) {
					$link='/kongress/fruehstuecks-workshop/';
				} elseif($veranstaltung->getTyp()==7 || $veranstaltung->getTyp()==8 || $veranstaltung->getTyp()==9 || $veranstaltung->getTyp()==10 || $veranstaltung->getTyp()==11 || $veranstaltung->getTyp()==12) {
					$link='/kongress/im-spezial/';
				} else {
					$link='/kongress/workshops-gruppengespraeche-one-to-one/';
				}
			}

				<td><a href="<?php echo $link; ?>?vid=<?php echo $veranstaltung->getVeranstaltung_id()."&gid=".$veranstaltung->getAussteller_id()."&gt=".$veranstaltung->getTyp(); ?>" style="text-decoration: underline;"><?php echo htmlentities($titel,ENT_COMPAT,"UTF-8"); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td><?php echo $referent; ?></td>
				<td style="white-space: nowrap;"><?php echo $startdatum; ?></td>
				<td style="white-space: nowrap;"><?php echo $lectureStartTime."-".$lectureEndTime; ?></td>
				<td style="white-space: nowrap;"><?php echo $ort; ?></td>
				<td style="text-align: right; white-space: nowrap;"><a href="?eID=icsterminkgv&k=<?php echo $this->kongressobj->getKongressId()."&tid=".$terminId; ?>" target="_blank" style="padding-right: 3px;"><img src="/content/im/templates/img/callendarIco.png" width="16" height="16" alt="In Kalender eintragen" title="In Kalender eintragen" /></a>

			if($this->teilnehmer_id!=$veranstaltung->getReferent2Id()) {

				<a href="javascript:void(0)" onClick="cancelVeranstaltung(<?php echo $veranstaltung_id; ?>);"><img src="/content/im/templates/img/round_delete_black.png" width="16" height="16" alt="Termin löschen" title="Termin löschen" /></a>

			}

				</td>
			</tr>

		}
	}
}
-->
        </table>

        <!-- TABELLE WARTELISTE ************************************************ -->
        <h3 class="buttonWaitlist">
          <img src="/content/im/templates/img/redDot.gif" width="6" height="6" style="padding-bottom: 2px;" alt="" title="" />
          <span>Für folgende Veranstaltungen stehen Sie auf der Warteliste</span> <img src="/content/im/templates/img/arrow_collapse.gif" class="arrow" alt="" width="10" height="10" />
        </h3>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="tableWaitlist" style="display: none; margin-bottom: 12px;" id="termintable_waitinglist">
          <tr>
            <th>Typ</th>
            <th>Thema/Firma</th>
            <th>Referent</th>
            <th>Tag <img src="/content/im/templates/img/arrow_expand.gif" alt="" width="10" height="10" /></th>
            <th>Uhrzeit <img src="/content/im/templates/img/arrow_expand.gif" alt="" width="10" height="10" /></th>
            <th colspan="2">Ort</th>
          </tr>
          <!--
if(is_array($this->wartelisten_ids)) {
	foreach($this->wartelisten_ids as $veranstaltung_id) {
		$veranstaltung=new FP_Veranstaltung($veranstaltung_id);
		$terminId=0;
		foreach($veranstaltung->getTeilnehmerliste() as $teilnehmerentry) {
			if($teilnehmerentry->teilnehmer_id==$this->teilnehmer->teilnehmer_id) $terminId=$teilnehmerentry->termin_id;
		}

			<tr class="dataRow" id="termintable_vid_<?php echo $veranstaltung_id; ?>">
				<td><?php
		$titel="";
		$referent="";
		if($veranstaltung->getTyp()==1) {
			echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_ws_black.gif" width="16" height="20" alt="Workshop" title="Workshop" /><strong>WS</strong>';
			$titel=$veranstaltung->getTitel();
			$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().", ".$veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
			$ort="";
			//$ort="Saal ".$veranstaltung->getOrt();
		} elseif($veranstaltung->getTyp()==2) {
			echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_gg_black.gif" width="16" height="20" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><strong>GG</strong>';
			$titel=$veranstaltung->getTitel();
			$referent="<b>Fragen:</b> ";
			$referent2titel=$veranstaltung->getReferent2Titel();
			$referent.=htmlentities((!empty($referent2titel)?$referent2titel." ":""),ENT_COMPAT,"UTF-8");
			$referent.=htmlentities($veranstaltung->getReferent2Vorname(),ENT_COMPAT,"UTF-8")." ";
			$referent.=htmlentities($veranstaltung->getReferent2Nachname(),ENT_COMPAT,"UTF-8").", ";
			$referent.=htmlentities($veranstaltung->getReferent2Firmenname(),ENT_COMPAT,"UTF-8")."<br/>";
			$referent.="<b>Antworten</b>: ".
				htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().", ".$veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
			$ort="Raum ".$veranstaltung->getOrt();
		} elseif($veranstaltung->getTyp()==3) {
			echo '<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_oo_black.gif" width="16" height="20" alt="One to One" title="One to One" /><strong>OO</strong>';
			$titel=$veranstaltung->getAussteller_Name();
			$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname(),ENT_COMPAT,"UTF-8");
			$ort="".$veranstaltung->getOrt();
		} elseif($veranstaltung->getTyp()>3) {
			echo $veranstaltung->getTypTextShort($veranstaltung->getTyp());

			$titel=$veranstaltung->getTitel();
			$referent=htmlentities((!empty($veranstaltung->getReferent1Titel)?$veranstaltung->getReferent1Titel()." ":"").$veranstaltung->getReferent1Vorname()." ".$veranstaltung->getReferent1Nachname().", ".$veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");
			$referent2=htmlentities((!empty($veranstaltung->getReferent2Titel)?$veranstaltung->getReferent2Titel()." ":"").$veranstaltung->getReferent2Vorname()." ".$veranstaltung->getReferent2Nachname(),ENT_COMPAT,"UTF-8");
			if($veranstaltung->getTyp()!=11 && trim($referent2)!="") $referent.=", ".$referent2.", ".htmlentities($veranstaltung->getAussteller_Name(),ENT_COMPAT,"UTF-8");

			if($veranstaltung->getTyp()==4 || $veranstaltung->getTyp()==5 || $veranstaltung->getTyp()==7 || $veranstaltung->getTyp()==8 || $veranstaltung->getTyp()==9 || $veranstaltung->getTyp()==10 || $veranstaltung->getTyp()==12) {
				$referent="Diskussion";
			}

			$ortTemp=$veranstaltung->getOrt();
			if($ortTemp=="Großer Saal") $ortTemp="Großer Saal";
			else $ort="Saal ".$veranstaltung->getOrt();
		}
		if($veranstaltung->getTyp()==3) {
			$teilnehmerBlocknummer=0;
			foreach($veranstaltung->o2oliste as $blocknummer=>$termin) {
				if($termin["teilnehmer_id"]==$this->teilnehmer_id) $teilnehmerBlocknummer=$blocknummer;
			}
			if($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=10) $startdatum=$this->kongressobj->getTag1Formatiert("kurz");
			elseif($teilnehmerBlocknummer>0 && $teilnehmerBlocknummer<=20) $startdatum=$this->kongressobj->getTag2Formatiert("kurz");
			else $startdatum="";
			$startEnde=$veranstaltung->getBlockZeitData($teilnehmerBlocknummer);
			$lectureStartTime 	= $startEnde[0];
			$lectureEndTime 	= $startEnde[1];
		} else {
			$startdatum=$veranstaltung->getStartDatum('dd.MM.YYYY');
			$lectureStartTime 	= $veranstaltung->getStartZeit();
			$lectureEndTime 	= $veranstaltung->getEndeZeit();
		}
			?></td>

if($this->kongressobj->getKongressId()<70) {
	$link='/kongress/kongress-'.$this->kongressobj->getTag1Formatiert('year').'/workshops-gruppengespraeche-one-to-one/';
} else {
	if($veranstaltung->getTyp()==6 || $veranstaltung->getTyp()==13) {
	    $link='/kongress/vortraege-der-starreferenten/';
	} elseif($veranstaltung->getTyp()==4 || $veranstaltung->getTyp()==5) {
	    $link='/kongress/fruehstuecks-workshop/';
	} elseif($veranstaltung->getTyp()==7 || $veranstaltung->getTyp()==8 || $veranstaltung->getTyp()==9 || $veranstaltung->getTyp()==10 || $veranstaltung->getTyp()==11 || $veranstaltung->getTyp()==12) {
	    $link='/kongress/im-spezial/';
	} else {
	    $link='/kongress/workshops-gruppengespraeche-one-to-one/';
	}
}

				<td><a href="<?php echo $link; ?>?vid=<?php echo $veranstaltung->getVeranstaltung_id()."&gid=".$veranstaltung->getAussteller_id()."&gt=".$veranstaltung->getTyp(); ?>" style="text-decoration: underline;"><?php echo htmlentities($titel,ENT_COMPAT,"UTF-8"); ?><img src="/content/im/templates/img/Kongresstool/link.gif" width="10" height="10" alt="Details" title="Details" style="padding-left: 3px;" /></a></td>
				<td><?php echo $referent; ?></td>
				<td style="white-space: nowrap;"><?php echo $startdatum; ?></td>
				<td style="white-space: nowrap;"><?php echo $lectureStartTime."-".$lectureEndTime; ?></td>
				<td style="white-space: nowrap;"><?php echo $ort; ?></td>
				<td style="text-align: right; white-space: nowrap;"><a href="?eID=icsterminkgv&k=<?php echo $this->kongressobj->getKongressId()."&tid=".$terminId; ?>" target="_blank" style="padding-right: 3px;"><img src="/content/im/templates/img/callendarIco.png" width="16" height="16" alt="In Kalender eintragen" title="In Kalender eintragen" /></a><a href="javascript:void(0)" onClick="cancelVeranstaltung(<?php echo $veranstaltung_id; ?>);"><img src="/content/im/templates/img/round_delete_black.png" width="16" height="16" alt="Termin löschen" title="Termin löschen" /></a></td>
			</tr>

	}
}
-->
        </table>
        <div class="spacer"><img src="/content/im/templates/img/Kongresstool/spacer.gif" width="1" height="12" alt="" title="" /></div>
      </div>
    {/if}
    <!-- SEITE 2 END ********************************************************************** -->

    <!-- SEITE 3 START ******************************************************************** -->
    {#if showPage == 3}
      <div id="panelContent03">
        <h3>SMS Benachrichtigung</h3>
        <p>
          Wenn Sie die SMS-Benachrichtigung unter Bekanntgabe Ihrer Mobilnummer aktivieren, erhalten Sie 10 Minuten vor Beginn Ihrer gebuchten Gruppengespräche und One2One-Termine ein Erinnerungs-SMS.
        </p>

        <p>
          <!--
            echo ( this- teilnehmer- sms_status==1?'checked="checked" ':'');
            echo ( this- teilnehmer- sms_status!=1 && $this->teilnehmer->sms_status!=0?'checked="checked" ':'');
-->
          <label style="width:170px;" for="sms_status">SMS-Benachrichtigung:</label><input type="radio" name="sms_status" id="sms_status_j" value="1" /> Ja &nbsp;&nbsp;&nbsp;
          <input type="radio" name="sms_status" id="sms_status_n" value="2" /> Nein
        </p>
        <div id="sms_nummer_p" style=" echo ($this->teilnehmer->sms_status==1?'':'display:none;'); ">
          <label style="width:170px;" for="tel">Mobilnummer:</label>
          <div id="sms_country" style="display:inline-block;width:25px;" />
          <input type="text" class="tel" pattern="\d*" x-autocompletetype="tel" placeholder="z.B. +49 ..." name="sms_nummer" id="sms_nummer" value="" />
        </div>
        <p>
          <button type="button" id="save_sms_data">Speichern</button>
        </p>
        <p class="copy-confirmation">Daten wurden gespeichert!</p>

        <div class="spacer"><img src="/content/im/templates/img/Kongresstool/spacer.gif" width="1" height="12" alt="" title="" /></div>
      </div>
    {/if}
    <!-- SEITE 3 END ********************************************************************** -->

    <div class="mailAppointmentList">
      <form action="" method="post" novalidate="">
        <label for="field2">E-Mail:</label>
        <span class="error" style="display: none;">Bitte geben Sie eine E-Mail Adresse ein.</span>
        <input type="email" name="field2" id="field2" required="required" /><br />
        <center>
          <input type="button" value="Absenden" class="submitMailAppointmentListWindow" />&nbsp;<input type="button" value="Abbrechen" class="closeMailAppointmentListWindow" />
        </center>
      </form>
    </div>

    <!-- FOOTER START ********************************************************************** -->
    <div id="panelFooter">
      <p class="page1" active="true">
        <button type="button" title="Seite 1">Seite 1</button>
      </p>
      <p class="page2" active="false">
        <button type="button" title="Seite 2">Seite 2</button>
      </p>
      <p class="page3" active="false">
        <button type="button" title="SMS Benachrichtigung">SMS Benachrichtigung</button>
      </p>
      <p>
        <!--
		    <a href="?eID=teilnehmerterminpdf&tid=<?php echo $this->teilnehmer->teilnehmer_id."&h=".sha1($this->teilnehmer->email); ?>" target="_blank">Termine als PDF</a><img src="/content/im/templates/img/pdf_ico_black.png" width="16" height="16" alt="Termine als PDF" title="Termine als PDF" /> | <a href="javascript:void(0)" class="mailAppointmentListTrigger">Termine-PDF per E-Mail</a><img src="/content/im/templates/img/mail.png" width="16" height="16" alt="Termine per E-Mail" title="Termine per E-Mail" />
-->
        <a href="?eID=teilnehmerterminpdf&tid= echo $this->teilnehmer->teilnehmer_id. &h= .sha1($this->teilnehmer->email); " target="_blank">Termine als PDF</a><img
          src="/content/im/templates/img/pdf_ico_black.png"
          width="16"
          height="16"
          alt="Termine als PDF"
          title="Termine als PDF"
        />
        |
        <button type="button" class="mailAppointmentListTrigger">Termine-PDF per E-Mail</button><img
          src="/content/im/templates/img/mail.png"
          width="16"
          height="16"
          alt="Termine per E-Mail"
          title="Termine per E-Mail"
        />
      </p>
    </div>
    <!-- FOOTER END ************************************************************************ -->
  </div>
{/if}
